<template>
  <div class="js-scroll-spy-section" :data-label="label">
    <slot></slot>
  </div>
</template>

<script>
  
  
  /**
   * Share Partial
   */

  export default {
    name: 'scroll-spy-section',
    data() {
      return {}
    },
    props: {
      label: {
        type: String,
        required: true
      },
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
  }
</script>



// WEBPACK FOOTER //
// src/plugins/scroll-spy/scroll-spy-section.vue